export const DUBAI = 4;
export const GOOGLE_MAP_TOKEN = process.env.REACT_APP_GOOGLE_MAP_TOKEN;
export const ZOOM_MAP_BUILDING = 18;
export const ZOOM_MAP_COMMUNITY = 16;
export const SATELLITE = "satellite";
export const ROAD_MAP = "roadmap";
export const ROOM_MAX_LIMIT = 12;
export const APARTMENT_GROUP_ID = 1;
export const VILLA_GROUP_ID = 3;
export const HOTEL_APARTMENT_ID = 3;
export const DATE_FORMAT_BACK = "YYYY-MM-DD";
export const DATE_FORMAT_FRONT = "DD MMM YYYY";
export const COMMA_SEPARATE_VALUE = "0,0";
export const COMPARABLE_STRING_LENGTH_LG = 25;
export const COMPARABLE_STRING_LENGTH_XL = 35;
export const COMPARABLE_STRING_LENGTH_XXL = 45;
export const CONFIDENCE_BAND_HIGH = 'High';
export const CONFIDENCE_BAND_MEDIUM = 'Medium';
export const CONFIDENCE_BAND_LOW = 'Low';
export const CONFIDENCE_NOT_AVAILABLE = 'N/A';
export const TRACK_ACTIVITY = 1; //1 for ON 0 for OFF
export const NUMBER_ORDINAL_SUFFIX = '0o'; // Add suffix after number eg: 1st or 22th
export const DEFAULT_TEXT_LIMIT = 600; // Define text limit and show view more when the text is big
export const PROPERTY_MONITOR_ID = 45; // Check property monitor company id
export const DEVICE_WIDTH = window.innerWidth // It will detect the device width
export const IS_MOBILE_WIDTH = 680 // Check mobile device width
export const MOCK_PDF_URL = 'https://s3.eu-west-1.amazonaws.com/avm.propertymonitor-assets/v1/436676/townhouse-no-60-zulal-1-zulal-the-lakes-emirates-living-dubai-united-arab-emirates-ec6467de3211a84329587d5426e3acc037af9323.pdf'
export const HOLO_COMPANY_ID = 1285;
export const T_AND_C_URL = 'https://propertymonitor.com/avm-user-terms-conditions';
export const QUERY_PARAM_FRAME_SRC = 'ZnJhbWVTcmM';
export const QUERY_PARAM_FRAME_SRC_VALUE = 'pm_app';